import { useAppSelector } from '../../hooks';
import quickBillPay from './quick-bill-pay.json';
import eligiblePaymentOverall from './eligible-payment-overall.json';
import notEligibleForPaymentArrangements from './not-eligble-for-payment-arrangements.json';
import accountSettingsPage from './account-settings-page.json';
import applyAcpModal from './apply-acp-modal.json';
import appointmentPage from './appointment-page.json';
import changeMyPlan from './change-my-plan.json';
import headerNav from './header-nav.json';
import helpAndSupportContent from './help-and-support-content.json';
import homePage from './home-page.json';
import loginForget from './login-forget.json';
import paymentPage from './payment-page.json';
import signupReset from './signup-reset.json';
import vacationPauseService from './vacation-pause-service.json';
import addAccount from './add-account.json';
import loginContent from './login-content.json';
import acpSignUp from './acp-signup.json'
import NetworkSetting from './network-settings.json';
import NonSuspend from './non-pay-suspend.json';
import footerHome from './footer-home-content.json';
import loginfooter from './am-login-footer.json';
import loginheader from './am-login-header.json';
import changeFlowContent from "./change-flow-content.json"
import WIFIExtContent from "./wifi-extender-content.json"
import WHWContent from "./whole-home-wifi.json"
import IqBundleContent from "./thic-bundle-content.json"
import commPreferanceContent from './communication-preferance.json';
import bannerNotification from './banner-notifications.json'
import postpaidFiberLocalContent from "./postpaid-fiber.json"
import dslmigratornewContent from './dsl-MigratorFiber/dsl-migrator.json'

const isProd = process.env.REACT_APP_ENV === "production"

interface contentResponseProps {
  isLocalFlag?: boolean | undefined;
  apiContent: object;
  localContent: object;
}

function contentResponse({ isLocalFlag, apiContent, localContent }: contentResponseProps) {
  const response = apiContent || localContent
  if (isProd) return response
  if (isLocalFlag) return localContent
  if(response !== undefined)
  return response
}

export function EligiblePaymentOverall() {
  const apiContent = useAppSelector(({ EligibleQBPPaymentContent: c }) => c?.EligibleQBPPaymentContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: eligiblePaymentOverall,
  });
}

export function QuickBillPay() {
  const apiContent = useAppSelector(( {quickBillPayContent: c} ) => c?.quickBillPayPageContent);
  return contentResponse({
    isLocalFlag: true,
    apiContent, 
    localContent: quickBillPay,
  })
}

export function NotEligibleForPaymentArrangements() {
  const apiContent = useAppSelector(({ notEligibleQBPPaymentContent: c }) => c?.notEligibleQBPPaymentContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: notEligibleForPaymentArrangements,
  });
}

export function AccountSettingsPageContent() {
  const apiContent = useAppSelector(({ accountSettingContent: c }) => c?.accountSettingPageContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: accountSettingsPage,
  });
}

export function ApplyAcpModalContent() {
  const apiContent = useAppSelector(({ applyAcpModalContent: c }) => c?.applyAcpModalPageContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: applyAcpModal,
  });
}

export function AppointmentPageContent() {
  const apiContent = useAppSelector(({ appointmentContent: c }) => c?.appointmentPageContent);
  return contentResponse({
    isLocalFlag: true,
    apiContent,
    localContent: appointmentPage,
  });
}

export function ChangeMyPlanContent() {
  const apiContent = useAppSelector(({ changePlanContent: c }) => c?.changePlanPageContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: changeMyPlan,
  });
}

export function HeaderNavContent() {
  const apiContent = useAppSelector(({ layoutContentDetails: c }) => c?.layoutContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: headerNav,
  });
}

export function HelpAndSupportContent() {
  const apiContent = useAppSelector(({ helpSupportContent: c }) => c?.helpSupportPageContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: helpAndSupportContent,
  });
}

export function HomePageContent() {
  const apiContent = useAppSelector(({ homePageContent: c }) => c?.homeScreenPageContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: homePage,
  });
}

export function LoginForgetContent() {
  const apiContent = useAppSelector(({ loginForgetPageContent: c }) => c?.loginForgetPageContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: loginForget,
  });
}

export function PaymentPageContent() {
  const apiContent = useAppSelector(({ paymentContent: c }) => c?.paymentPageContent);
  return contentResponse({
    isLocalFlag: true,
    apiContent,
    localContent: paymentPage,
  });
}

export function SignupResetContent() {
  const apiContent = useAppSelector(({ signUpResetPageContent: c }) => c?.signupResetPageContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: signupReset,
  });
}

export function VacationPauseServiceContent() {
  const apiContent = useAppSelector(({ vacationPauseServiceContent: c }) => c?.vacationPauseServicePageContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: vacationPauseService,
  });
}

export function AddAccountContent() {
  const apiContent = useAppSelector(({ getaddAccountContent: c }) => c?.addAccounPageContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: addAccount,
  });
}

export function LoginContent() {
  const apiContent = useAppSelector(({ contentDetails: c }) => c?.loginPageContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: loginContent,
  });
}

export function ACPSignUpContent() {
  const apiContent = useAppSelector(({ acpFormContent: c }) => c?.acpFormPageContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: acpSignUp,
  });
}

export function NetworkSettingsContent() {
  const apiContent = useAppSelector(({ networkSettings: c }) => c?.networkSettingsPageContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent,
    localContent: NetworkSetting,
  });
}

export function NonPaySuspendContent() {
  const apiContent = useAppSelector(({ nonPaySuspendContent: c }) => c?.nonPaySuspendPageContent);
  return contentResponse({
    isLocalFlag: true,
    apiContent,
    localContent: NonSuspend,
  });
}

export function HomeFooterContent() {
  const apiContent = useAppSelector(({ homeFooterContent: c }) => c?.homeFooterPageContent);
  return contentResponse({
    isLocalFlag: true,
    apiContent,
    localContent: footerHome
  });
}

export function LoginFooterContent() {
  const apiContent = useAppSelector(({ loginFooterContent: c }) => c?.loginFooterPageContent);
  return contentResponse({
    isLocalFlag: true,
    apiContent,
    localContent: loginfooter,
  });
}

export function LoginHeaderContent() {
  const apiContent = useAppSelector(({ loginHeaderContent: c }) => c?.loginHeaderContent);
  return contentResponse({
    isLocalFlag:true,
    apiContent,
    localContent: loginheader,
  });
}

export function BannerNotificationContent() {
  const apiContent = useAppSelector(({ bannerNotification: c }) => c?.bannerNotification);
  return contentResponse({
    isLocalFlag: true,
    apiContent,
    localContent: bannerNotification,
  });
}
// Fiber retention and price lock content has to be moved to AEM-2171
export function ShopEXPContent() {
  const apiContent = useAppSelector(({ changeFlowContent: c }) => c?.changeFlowContent);
  return contentResponse({
    isLocalFlag: false, 
    apiContent,
    localContent: changeFlowContent,
  });
}

// DSL- migrator New banners
export function DslmigratorContent() {
  const apiContent = useAppSelector(({ dslmigratorNewContent: c }) => c?.dslmigratorNewContent);
  return contentResponse({
    isLocalFlag: true,
    apiContent,
    localContent: dslmigratornewContent,
  });
}

export  function IQBundleContent(){
  const apiContent = useAppSelector(({ ThicBundleContent: c }) => c?.ThicBundleContent);
  return contentResponse({
    isLocalFlag: false, 
    apiContent: apiContent,
    localContent: IqBundleContent,
  });
}

export  function WifiExContent(){
  const apiContent = useAppSelector(({ WifiExtenderContent: c }) => c?.WifiExtenderContent);
  return contentResponse({
    isLocalFlag: false, 
    apiContent: apiContent,
    localContent: WIFIExtContent,
  });
}

export  function WholeHomeWifiContent(){
  const apiContent = useAppSelector(({ WholeHomeWifiContent: c }) => c?.WholeHomeWifiContent);
  return contentResponse({
    isLocalFlag: false, 
    apiContent: apiContent,
    localContent: WHWContent,
  });
}

export function CommPrefContent() {
  const apiContent = useAppSelector(({ communicationPreferenceContent: c }) => c?.communicationPreferenceContent);
  return contentResponse({
    isLocalFlag: false,
    apiContent, 
    localContent: commPreferanceContent,
  })
}

export function PostpaidFiberContent() {
  const apiContent = useAppSelector(({ postpaidFiberContent: c }) => c?.postpaidFiberContent);
  return contentResponse({
    isLocalFlag: true,
    apiContent, 
    localContent: postpaidFiberLocalContent,
  })
}